
import { store as notifications } from 'react-notifications-component';


export const setDashboardActiveTab= async (store, tabname) => {
    store.setState({ 
        ...store.state,
        ui: {
            ...store.state.ui,
            dashboard: {
                ...store.state.dashboard,
                activeTab: tabname
            }
        }
    });
}

export const toggleMobileSubmenu= async (store) => {
    store.setState({ 
        ...store.state,
        ui: {
            ...store.state.ui,
            menu: {
                ...store.state.ui.menu,
                showMobileSubmenu: !store.state.ui.menu.showMobileSubmenu
            }
        }
    });
}

export const setGiftlistActiveTab= async (store, tabname) => {
    store.setState({ 
        ...store.state,
        ui: {
            ...store.state.ui,
            giftlist: {
                ...store.state.giftlist,
                activeTab: tabname
            }
        }
    });
}

export const resetActiveGiftlist = async (store) => {
    store.setState({ 
        ...store.state,
        activeGiftlist: {
            user: null,
            giftlist: [],
            archive: []
        },
        ui: {
            ...store.state.ui,
            giftlist: {
                activeTab: "giftlist"
            }
        }
    });
}

export const toggleSidePanel= async (store, sidepanel, state={}, open=true) => {
    if(sidepanel === "additem") {
        state = {
            activeTab: "website",
            ...state
        };
        console.log('set sidepanel state to', state);
    }
    store.setState({ 
        ...store.state,
        ui: {
            ...store.state.ui,
            sidepanel: {
                ...store.state.sidepanel,
                name: sidepanel,
                open: open,
                state: state
            }
        }
    });
}

export const closeSidePanel= async (store) => {
    store.setState({ 
        ...store.state,
        ui: {
            ...store.state.ui,
            sidepanel: {
                ...store.state.sidepanel,
                open: false
            }
        }
    });
}

export const updateSidePanelState= async (store, newState={}) => {
    console.log('update sidepanel state', newState);
    store.setState({ 
        ...store.state,
        ui: {
            ...store.state.ui,
            sidepanel: {
                ...store.state.ui.sidepanel,
                state: {
                    ...store.state.ui.sidepanel.state,
                    ...newState
                }
            }
        }
    });
}

export const clearResponse = async (store) => {
    const response = null;
    store.setState({ response });
}


export const createNotification = async (store, title='', message='', type='success') => {
    notifications.addNotification({
        title: title,
        message: message,
        type: type,
        insert: "top",
        container: "bottom-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
    });
}